<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>What is easyJet Plus?<Caret /></summary>
  <p>
    easyJet Plus is an annual membership that offers priority services such as free seat selection, additional baggage
    allowances, faster boarding, fast track security and dedicated bag drop among other benefits. As part of the
    settlement, you are being offered 12 months free membership. This usually costs £249.00.
  </p>
  <p>
    More information about the membership and how to claim it is contained in your portal.
  </p>
</details>
